/* eslint-disable no-undef */
import React, { useEffect, useRef } from "react";
import CardOne from "./CardOne";
export default function Carrusel({ items }) {

  const refCarrusel = useRef();

  useEffect(() => {

    if (refCarrusel.current) {

      $(refCarrusel.current).owlCarousel({
        items: 3,
        loop: true,
        margin: 20,
        autoplay: false,
        dots: true,
        nav: false,
        responsive: {
          0: {
            items: 1
          },
          900: {
            items: 2
          },
          1300: {
            items: 3
          }
        }
      });
    }

    // Función de limpieza: destruir el carrusel cuando el componente se desmonte
    return () => {
      if (refCarrusel.current) {
        $(refCarrusel.current).owlCarousel('destroy');
      }
    };

  }, []);

  return (
    <div ref={refCarrusel} className="owl-carousel">
      {items.map((item, index) => {

        // return <CardOne key={index} descripcion={item.descripcion} titulo={item.titulo} web={item.web} git={item.git} imagen={item.imagen} tecnologia={item.tecnologias} />;
        return <CardOne key={index} item={item} />;

      })}

    </div>
  );
}
